import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// 按需导入图标
// 定义你实际用到的图标白名单
const USED_ICONS = [
    'DocumentCopy', 'Filter', 'Setting', 'SwitchButton', 'Edit',
    'View', 'Hide', 'SortUp', 'UploadFilled', 'Eleme', 'Search',
    'ChatDotRound', 'Connection', 'MessageBox', 'Tickets', 'Postcard',
    'Document', 'Files', 'Star', 'Expand', 'Opportunity', 'Loading',
    'Paperclip', 'CirclePlusFilled', 'MagicStick', 'Clock', 'CircleCheck',
    'CircleClose', 'CircleCloseFilled', 'Refresh', 'Message', 'Odometer',
    'Notification', 'Key', 'InfoFilled', 'CaretTop', 'CaretBottom',
    'QuestionFilled'
]

export function registerIcons(app) {
    USED_ICONS.forEach(name => {
        if (ElementPlusIconsVue[name]) {
            app.component(name, ElementPlusIconsVue[name])
        }
    })
}